import { HttpTypes } from "@medusajs/types"

type ProductLike =
  | (Pick<HttpTypes.StoreProduct, "metadata"> & {
      metadata?: Record<string, unknown> | null
    })
  | { metadata?: Record<string, unknown> | null }
  | null
  | undefined

const DAY_MS = 24 * 60 * 60 * 1000

function parseDays(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) {
    return Math.max(0, Math.floor(value))
  }
  if (typeof value === "string" && value.trim()) {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? Math.max(0, Math.floor(parsed)) : null
  }
  return null
}

export function isNewProduct(product: ProductLike, now = new Date()): boolean {
  const metadata = product?.metadata
  if (!metadata) return false

  const days = parseDays(metadata.new_badge_days)
  if (!days) return false

  const publishedAtValue = metadata.first_published_at
  if (typeof publishedAtValue !== "string" || !publishedAtValue.trim()) {
    return false
  }

  const publishedAt = new Date(publishedAtValue)
  const nowTime = now.getTime()
  const publishedTime = publishedAt.getTime()
  if (!Number.isFinite(publishedTime) || !Number.isFinite(nowTime)) {
    return false
  }

  return nowTime >= publishedTime && nowTime < publishedTime + days * DAY_MS
}
